import React from 'react'
import { GET_MERCHANT_INTEGRATION_SETTINGS } from 'components/Integrations/queries'
import { MerchantIntegrationSettings } from 'components/Integrations/types'
import { useIntegration } from 'hooks/useGlobalContext/useIntegration'
import { LoaderProps } from './types'
import { useFetchOnce } from './useFetchOnce'

// Merchant-wide integration settings (getMerchantIntegrations), read by
// ManageLeat — shared GraphQL data, so Loader/Context per
// doc/ARCHITECTURE.md §6. Distinct from MerchantIntegrationsLoader, which
// loads the connected-partners list (partners_merchants) into useMerchant.
export const MerchantIntegrationSettingsLoader = ({
  isParentLoaded = true,
  children
}: LoaderProps) => {
  const {
    merchantIntegrations,
    setMerchantIntegrations,
    setRefetchMerchantIntegrations
  } = useIntegration()

  const { isLoaded } = useFetchOnce<{
    getMerchantIntegrations: MerchantIntegrationSettings
  }>({
    query: GET_MERCHANT_INTEGRATION_SETTINGS,
    skip: merchantIntegrations !== null,
    onData: (data) => {
      if (data.getMerchantIntegrations) {
        setMerchantIntegrations(data.getMerchantIntegrations)
      }
    },
    onRefetch: (refetch) => {
      const refetchAndSync = async () => {
        const result = (await refetch()) as {
          data?: { getMerchantIntegrations: MerchantIntegrationSettings }
        }
        if (result.data?.getMerchantIntegrations) {
          setMerchantIntegrations(result.data.getMerchantIntegrations)
        }
        return result
      }

      setRefetchMerchantIntegrations(
        (() => refetchAndSync) as unknown as () => Promise<unknown>
      )
    },
    isParentLoaded
  })

  return <React.Fragment>{children(isLoaded)}</React.Fragment>
}
